import { useEffect, useState } from 'react';
import { getObjectLength } from '../utils/util';

const useButtonDisable = (
  {
    fieldValidation,
    isStateControlled,
    isSubmitButtonDisable,
    fieldName,
    disabledButtons,
    fieldId,
  }) => {
  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
    if (fieldValidation.disabled) {
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }
  }, [fieldValidation.disabled]);

  useEffect(() => {
    // old implementation --> use disableButtons in new forms
    if (!isStateControlled) {
      if (fieldValidation.isMandatoryFileUpload || fieldValidation.isUserConsentRequired) {
        if (isSubmitButtonDisable) {
          setIsDisabled(true);
        } else if (!isSubmitButtonDisable) {
          setIsDisabled(false);
        }
      }
    }
  }, [isSubmitButtonDisable]);

  useEffect(() => {
    if (isStateControlled) {
      if (fieldName) {
        /**
         * Introduced this to differentiate between same fieldIds across different pages.
         * e.g. continue button is present across different pages.
         */
        if (disabledButtons && disabledButtons[fieldName]
          && getObjectLength(disabledButtons[fieldName]) > 0 && !isDisabled) {
          setIsDisabled(true);
        } else if (isDisabled) {
          setIsDisabled(false);
        }
      } else if (disabledButtons && disabledButtons[fieldId]
        && getObjectLength(disabledButtons[fieldId]) > 0) {
        if (!isDisabled) setIsDisabled(true);
      } else if (isDisabled) setIsDisabled(false);
    }
  }, [disabledButtons]);

  return isDisabled;
};

export default useButtonDisable;
